import { FC } from 'react';
import { ImageBoxFuture } from './image-box-future';
import { useIntl } from 'react-intl';

interface Icon24Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  title: string;
}
export const Icon24: FC<Icon24Props> = ({ icon, title }) => {
  const intl = useIntl();
  return (
    <ImageBoxFuture
      img={icon}
      title={intl.formatMessage({
        id: title,
      })}
      objectFit='contain'
      sx={{
        minWidth: '24px',
        minHeight: '24px',
      }}
    />
  );
};

export default Icon24;
